/**
 * @flow
 * @relayHash 9fc8fd0dbba5fd0bb57fec7658c3d86b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CustomerOriginCreateInput = {|
  name: string
|};
export type CreateCustomerOriginMutationVariables = {|
  data: CustomerOriginCreateInput
|};
export type CreateCustomerOriginMutationResponse = {|
  +createCustomerOrigin: {|
    +id: string
  |}
|};
export type CreateCustomerOriginMutation = {|
  variables: CreateCustomerOriginMutationVariables,
  response: CreateCustomerOriginMutationResponse,
|};
*/


/*
mutation CreateCustomerOriginMutation(
  $data: CustomerOriginCreateInput!
) {
  createCustomerOrigin(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CustomerOriginCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createCustomerOrigin",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CustomerOriginModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateCustomerOriginMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateCustomerOriginMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateCustomerOriginMutation",
    "id": null,
    "text": "mutation CreateCustomerOriginMutation(\n  $data: CustomerOriginCreateInput!\n) {\n  createCustomerOrigin(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f77d825471d4542dd57f5efaa863d77e';
module.exports = node;
